export default __webpack_public_path__ + "static/media/equipments.e4eda5fd.svg";